import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import Rotation from './Rotation';
import { Redirect } from 'react-router-dom';
import { getAgenciesFullPermission } from 'reducers/PermissionsReducer';
function RotationsSearch() {
  const canReadAgencies = getAgenciesFullPermission('cad', 'Events', 'Read');
  if (!canReadAgencies.length) return <Redirect to="/" />;
  return (
    <SearchMenu agencyList={canReadAgencies}>
      <FilterConsumer>{(AgencyFilter) => <Rotation filter={AgencyFilter} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default RotationsSearch;
